import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { useEffect, useState } from "react";
import {
  IconAutomation,
  IconBrandRust,
  IconChartBar,
  IconChartHistogram,
  IconPasswordUser,
  IconReceipt2,
  IconReportAnalytics,
  IconShoppingCart,
  IconTruckDelivery,
  IconUserPlus,
  IconUsers,
  IconUserShare,
  IconUserStar,
} from "@tabler/icons-react";
import { formatRole } from "../../utils/_helpers";
import { toast } from "react-toastify";

const roleIcons = {
  superadmin: <IconUserPlus stroke={1} size={33} />,
  sales: <IconReportAnalytics stroke={1} size={33} />,
  finance: <IconReceipt2 stroke={1} size={33} />,
  admin: <IconUserStar stroke={1} size={33} />,
  logistics: <IconTruckDelivery stroke={1} size={33} />,
  trackingsales: <IconChartHistogram stroke={1} size={33} />,
  purchasing: <IconShoppingCart stroke={1} size={33} />,
  businessdevelopment: <IconChartBar stroke={1} size={33} />,
  customersuccess: <IconUsers stroke={1} size={33} />,
  engineering: <IconAutomation stroke={1} size={33} />,
};

const AssignRoleModal = ({ isOpen, onClose, fetchUsers }) => {
  const {user} = isOpen
  const initialRoles = user?.Roles?.map((r) => r?.name) || [];
  const [selectedRole, setSelectedRole] = useState(initialRoles || []);
  const { postData: fetchRoles, data: roles } = usePostRequest(
    API_ENDPOINTS.GET_ROLES
  );
  const { postData: assignRoles, isLoading } = usePostRequest(
    API_ENDPOINTS.ASSIGN_ROLES
  );

  const handleSelectRole = (role) => {
    setSelectedRole((prevState) => {
      if (prevState.includes(role?.name)) {
        return prevState.filter((r) => r !== role?.name);
      }
      return [...prevState, role?.name];
    });
  };

  const isRoleSelected = (role) => {
    return selectedRole.includes(role?.name);
  };

  const onAssignRoleSuccess = (response) => {
    toast.success(response.message);
    fetchUsers();
    onClose();
  };

  const onAssignRoleError = (error) => {
    toast.error(error.message);
  };

  const handleAssignRoles = () => {
    if (selectedRole?.length > 0) {
      const payload = {
        roles: selectedRole,
        username: user?.username,
      };
      assignRoles(payload, onAssignRoleSuccess, onAssignRoleError);
    } else {
      toast.dismiss();
      toast.error("Please Select at least one role");
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  return (
    <Modal centered show={isOpen?.show} onHide={onClose}>
      <Modal.Header className="gap-2 align-items-center" closeButton>
        <span className="avatar bg-lime-lt rounded-circle"><IconUserShare /></span>
        <div>
          <Modal.Title>Assign Roles</Modal.Title>
          <Card.Subtitle>You can select multiple assign roles</Card.Subtitle>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="space_row">
            {roles?.data?.map((role) => {
              const iconName = formatRole(role?.name);
              return (
                <Col md={3} xs={6} className="mb-2">
                <div
                  className={`position-relative d-flex flex-column align-items-center justify-content-center radio-box ${
                    isRoleSelected(role)
                      ? "border-lime active-radio-box"
                      : ""
                  }`}
                  key={role?.id}
                  onClick={() => handleSelectRole(role)}
                >
                  <span
                    className={`position-absolute rounded-circle ${
                      isRoleSelected(role) ? "p-1" : "p-2"
                    }`}
                    style={{
                      top: "5%",
                      right: "4%",
                      border: isRoleSelected(role)
                        ? "5px solid var(--orange-theme-color)"
                        : "1px solid #DCE1E7",
                    }}
                  ></span>
                  {roleIcons[iconName]}
                  <span>{role?.name}</span>
                </div>
                </Col>
              );
            })}
          
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-warning" onClick={handleAssignRoles}>
          {isLoading ? "Loading..." : "Assign Roles"}
        </Button>
        <Button onClick={onClose} variant="outline-secondary">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssignRoleModal;
